"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(array) {
  return array[array.length - 1];
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/getLastElement.js
// module id = 2038
// module chunks = 0